type GeoResponse = {
  status: string;
  country: string;
  countryCode: string;
  region: string;
  regionName: string;
  city: string;
  timezone: string;
};

let lastCallTimestamp = 0;
const MIN_INTERVAL_MS = 5_000;

export async function getGeoData(): Promise<GeoResponse | null> {
  const now = Date.now();
  if (now - lastCallTimestamp < MIN_INTERVAL_MS) {
    return null;
  }
  lastCallTimestamp = now;

  try {
    const response = await fetch('https://ipapi.co/json/', {
      headers: { Accept: 'application/json' },
    });

    if (!response.ok) return null;

    const data = await response.json();
    if (data.error) return null;

    return {
      status: 'success',
      country: data.country_name || 'Unknown',
      countryCode: data.country_code || data.country || '',
      region: data.region_code || '',
      regionName: data.region || '',
      city: data.city || '',
      timezone: data.timezone || '',
    };
  } catch {
    return null;
  }
}
